import React from "react";
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Button,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import FilesManager from "../../../components/FilesManager";

const MediaUploadDialog = ({
  open,
  onClose,
  files,
  accept,
  onDrop,
  onDragEnter,
  onDragLeave,
  onSelectionChange,
  onNewFolder,
  onUploadDialog,
  refresh,
  filesManagerRef,
  tr,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      sx={{
        "& .MuiPaper-root": {
          borderRadius: "10px",
          backgroundColor: "var(--background-menu)",
        },
      }}>
      <Box
        sx={{
          backgroundColor: "var(--background-image)",
          borderRadius: "10px",
        }}
        onDrop={onDrop}
        onDragOver={onDragEnter}
        onDragLeave={onDragLeave}
        onDragEnter={onDragEnter}>
        <DialogTitle
          className="flex between items-center"
          sx={{ color: "var(--text-color)" }}
          id="alert-dialog-title">
          {tr("postPage.uploadMedia")}
          <Button onClick={onClose}>
            <CloseIcon sx={{ color: "var(--text-color)" }} />
          </Button>
        </DialogTitle>
        <DialogContent>
          <Box className="flex flex-wrap -mx-2 scrolling">
            <FilesManager
              ref={filesManagerRef}
              files={files}
              accept={accept}
              size="small"
              onSelectionChange={onSelectionChange}
              refresh={refresh}
              width={126}
              height={135}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Box className="btnDark" onClick={onNewFolder}>
            {tr("postPage.addFolder")}
          </Box>
          <Box className="btnDark" onClick={onUploadDialog}>
            {tr("postPage.addFile")}
          </Box>
        </DialogActions>
      </Box>
    </Dialog>
  );
};

export default MediaUploadDialog;
